module.exports = __webpack_public_path__ + "static/Design_v2-opt-2b0d516aa64e1446bf04b28bc905785d.mp4";